import React, {useEffect} from 'react';
import {useBooleanAssignment} from '@ezcater/eppo-react';
import {useSidebar} from '@src/components/shadcn/sidebar';
import {Link} from 'react-router-dom';
import EzManageNavLinkLogo from '@src/icons/EzManageNavLinkLogo';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faXmarkLarge} from '@fortawesome/pro-light-svg-icons';
import cn from '@src/util/cnHelper';
import EppoFlags from '@src/EppoFlags';
import {NavItem} from './types';

const NavHeader = ({homeNavItem}: {homeNavItem: NavItem}) => {
  const {isMobile, openMobile, setOpenMobile} = useSidebar();
  const shouldShowRebrandLogo = useBooleanAssignment(EppoFlags.LogoRebrandMajor, false);

  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [isMobile, setOpenMobile]);

  const toggleMobileNavbar = () => {
    setOpenMobile(!openMobile);
  };
  return (
    <div
      className={cn(
        'flex justify-between inset-0 w-full md:w-[--sidebar-width]',
        shouldShowRebrandLogo
          ? 'pt-5 pb-2 px-6 items-start border-r border-peppercorn-200'
          : 'h-12 px-5 items-center'
      )}
    >
      <Link className="block" to={homeNavItem.to}>
        <EzManageNavLinkLogo />
      </Link>
      {isMobile && (
        <FontAwesomeIcon
          onClick={toggleMobileNavbar}
          className="cursor-pointer"
          icon={openMobile ? faXmarkLarge : faBars}
        />
      )}
    </div>
  );
};

export default NavHeader;
